import nameOf from "./nameOf.helper";
import { CustomEntity } from "src/app/models/customEntity.model";
import { CustomField } from "src/app/models/customField.model";
import { EmployeeCustomFields } from "src/app/enums/customFieldType.enum";
import { Agent } from "src/app/models/agent.model";

export const EMPLOYEE_BASE_LABEL_MAP: Record<string, string> = {
    [nameOf<CustomEntity>((x) => x.name)]: "Id",
    [nameOf<CustomEntity>((x) => x.organizationLevelName)]:
        "Organization Level Name",
};

export const AGENT_OPTION_LABEL_MAP: Record<string, string> = {
    [nameOf<Agent>((x) => x.name)]: "Name",
    [nameOf<Agent>((x) => x.casId)]: "Code",
};

export function buildEmployeeOptionConfig(
    employeeCustomFields: CustomField[],
): {
    optionTemplateFields: string[];
    optionTemplateLabelMap: Record<string, string>;
} {
    const filtered = employeeCustomFields.filter((f) =>
        EmployeeCustomFields.includes(f.type),
    );
    return {
        optionTemplateFields: [
            nameOf<CustomEntity>((x) => x.name),
            nameOf<CustomEntity>((x) => x.organizationLevelName),
            ...filtered.map((f) => f.property),
        ],
        optionTemplateLabelMap: {
            ...EMPLOYEE_BASE_LABEL_MAP,
            ...Object.fromEntries(
                filtered.map((f) => [
                    f.property,
                    f.name.replace(/^HRIS\s*/, ""),
                ]),
            ),
        },
    };
}
